module.exports = __webpack_public_path__ + "static/Quote 2 - Mobile-4d52fae3b499f695b245e0d91c8ec139.png";